var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconLanguage = function SvgIconLanguage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 14a6.003 6.003 0 0 1-5.725-4.2M8 14a6.003 6.003 0 0 0 5.725-4.2M8 14s-1.622-1.622-2.2-4.2M8 14s1.622-1.622 2.2-4.2M8 2a6.003 6.003 0 0 1 5.725 4.2M8 2a6.003 6.003 0 0 0-5.725 4.2M8 2s1.622 1.622 2.2 4.2M8 2S6.378 3.622 5.8 6.2m7.925 0c.179.568.275 1.173.275 1.8s-.096 1.232-.275 1.8m0-3.6H10.2m-7.924 0A5.997 5.997 0 0 0 2 8c0 .627.096 1.232.275 1.8m0-3.6H5.8M2.275 9.8H5.8m7.924 0H10.2m0-3.6c.125.558.201 1.16.201 1.8 0 .64-.076 1.242-.2 1.8m0-3.6H5.8m0 0a8.228 8.228 0 0 0 0 3.6m0 0h4.4",
    stroke: "#fff",
    strokeOpacity: 0.75
  })));
};
export default SvgIconLanguage;